import React from "react";

/**
 * VITAE-PUBLICA™ Logo
 * Fusion symbolique : balance de justice (équité publique) + sablier (vie humaine qui s'écoule).
 * Les deux plateaux de la balance sont remplacés par des sabliers — signifiant que chaque décision
 * publique pèse du temps de vie humaine.
 *
 * Props:
 *   size   : pixel size of the square glyph
 *   tone   : "blue" | "gold" — primary stroke color
 *   accent : "blue" | "gold"
 */
export default function Logo({
  size = 40,
  tone = "blue",
  accent = "gold",
  className = "",
}) {
  const strokeColor = tone === "gold" ? "#C9A84C" : "#1A3C5E";
  const accentColor = accent === "blue" ? "#1A3C5E" : "#C9A84C";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="VITAE-PUBLICA — balance de justice et sablier"
      className={className}
    >
      {/* Central vertical axis — la colonne institutionnelle */}
      <line
        x1="32"
        y1="10"
        x2="32"
        y2="56"
        stroke={strokeColor}
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      {/* Apex dot */}
      <circle cx="32" cy="9" r="2.2" fill={accentColor} />

      {/* Horizontal beam */}
      <line
        x1="10"
        y1="20"
        x2="54"
        y2="20"
        stroke={strokeColor}
        strokeWidth="2.2"
        strokeLinecap="round"
      />

      {/* Left hourglass (pan) */}
      <g transform="translate(10,20)">
        <line x1="0" y1="0" x2="0" y2="3" stroke={strokeColor} strokeWidth="1.6" />
        <path
          d="M -6 3 L 6 3 L -6 17 L 6 17 Z"
          stroke={strokeColor}
          strokeWidth="2"
          strokeLinejoin="round"
          fill="none"
        />
        {/* top sand */}
        <path d="M -4 5 L 4 5 L 0 9 Z" fill={accentColor} />
        {/* bottom sand */}
        <path d="M -4 15 L 4 15 L 0 11 Z" fill={accentColor} opacity="0.7" />
        {/* base */}
        <line x1="-7" y1="17" x2="7" y2="17" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" />
      </g>

      {/* Right hourglass (pan) */}
      <g transform="translate(54,20)">
        <line x1="0" y1="0" x2="0" y2="3" stroke={strokeColor} strokeWidth="1.6" />
        <path
          d="M -6 3 L 6 3 L -6 17 L 6 17 Z"
          stroke={strokeColor}
          strokeWidth="2"
          strokeLinejoin="round"
          fill="none"
        />
        <path d="M -4 5 L 4 5 L 0 9 Z" fill={accentColor} />
        <path d="M -4 15 L 4 15 L 0 11 Z" fill={accentColor} opacity="0.7" />
        <line x1="-7" y1="17" x2="7" y2="17" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" />
      </g>

      {/* Base pedestal */}
      <path
        d="M 22 56 L 42 56 M 26 52 L 38 52"
        stroke={strokeColor}
        strokeWidth="2.2"
        strokeLinecap="round"
      />
    </svg>
  );
}
